import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b012bb4")

_pushScopeId("data-v-3b012bb4")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "text" }, "Zveřejněné slevové kódy", -1)
const _hoisted_2 = { id: "promocode-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DropdownSelector = _resolveComponent("DropdownSelector")
  const _component_ThePromocodeListItem = _resolveComponent("ThePromocodeListItem")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_DropdownSelector, {
      label: "Stav:",
      items: _ctx.promocodeStates,
      idField: "id",
      displayField: "name",
      valueField: "value",
      onSelect: _ctx.onItemSelect
    }, null, 8, ["items", "onSelect"]),
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.promocodes, (promocodeItem, index) => {
        return (_openBlock(), _createBlock("li", {
          key: promocodeItem.id
        }, [
          _createVNode(_component_ThePromocodeListItem, {
            onRemovePromocode: _ctx.removePromocodeFromList,
            "promocode-item": promocodeItem,
            index: index,
            appliers: _ctx.appliers,
            onEditPromocode: _ctx.editPromocode,
            onInvokeError: _ctx.invokeError,
            onInvokeSuccess: _ctx.invokeSuccess
          }, null, 8, ["onRemovePromocode", "promocode-item", "index", "appliers", "onEditPromocode", "onInvokeError", "onInvokeSuccess"])
        ]))
      }), 128))
    ])
  ], 64))
})